
import { mapActions } from 'vuex'

export default {
  data: () => ({
    descriptionLimit: 60,
    entries: [],
    isLoading: false,
    model: null,
    search: null,
  }),

  computed: {
    fields() {
      if (!this.model) return []
      return Object.keys(this.model).map(key => ({
        key,
        value: this.model[key] || 'n/a',
      }))
    },
    items() {
      return this.entries.map(entry => {
        const Description = entry.description.length > this.descriptionLimit
          ? entry.description.slice(0, this.descriptionLimit) + '...'
          : entry.description

        return Object.assign({}, entry, { Description })
      })
    },
  },

  watch: {
    search(val) {
      if (this.isLoading || !val) return

      this.isLoading = true
      this.autocomplete({ text: val })
        .then(data => {
          if (data && data.predictions) {
            this.entries = data.predictions
          } else {
            this.entries = []
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
    },

    model(newVal) {
      if (this.isLoading) return

      this.isLoading = true
      if (newVal && newVal.place_id) {
        this.$emit("getLatLng", newVal.place_id)
      }
      this.isLoading = false
    }
  },

  methods: {
    ...mapActions('map', ['autocomplete', 'placeDetails'])
  }
}
